/* tslint:disable */
/* eslint-disable */
/**
 * NoRadio Backend
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 0.1.0
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
import type { EpisodeAdminModel } from './EpisodeAdminModel';
import {
    EpisodeAdminModelFromJSON,
    EpisodeAdminModelFromJSONTyped,
    EpisodeAdminModelToJSON,
} from './EpisodeAdminModel';

/**
 *
 * @export
 * @interface ListEpisodeAdminResponse
 */
export interface ListEpisodeAdminResponse {
    /**
     *
     * @type {number}
     * @memberof ListEpisodeAdminResponse
     */
    limit: number;
    /**
     *
     * @type {number}
     * @memberof ListEpisodeAdminResponse
     */
    offset: number;
    /**
     *
     * @type {number}
     * @memberof ListEpisodeAdminResponse
     */
    total: number;
    /**
     *
     * @type {Array<EpisodeAdminModel>}
     * @memberof ListEpisodeAdminResponse
     */
    episodes: Array<EpisodeAdminModel>;
}

/**
 * Check if a given object implements the ListEpisodeAdminResponse interface.
 */
export function instanceOfListEpisodeAdminResponse(value: object): boolean {
    if (!('limit' in value)) return false;
    if (!('offset' in value)) return false;
    if (!('total' in value)) return false;
    if (!('episodes' in value)) return false;
    return true;
}

export function ListEpisodeAdminResponseFromJSON(json: any): ListEpisodeAdminResponse {
    return ListEpisodeAdminResponseFromJSONTyped(json, false);
}

export function ListEpisodeAdminResponseFromJSONTyped(
    json: any,
    ignoreDiscriminator: boolean,
): ListEpisodeAdminResponse {
    if (json == null) {
        return json;
    }
    return {
        limit: json['limit'],
        offset: json['offset'],
        total: json['total'],
        episodes: (json['episodes'] as Array<any>).map(EpisodeAdminModelFromJSON),
    };
}

export function ListEpisodeAdminResponseToJSON(value?: ListEpisodeAdminResponse | null): any {
    if (value == null) {
        return value;
    }
    return {
        limit: value['limit'],
        offset: value['offset'],
        total: value['total'],
        episodes: (value['episodes'] as Array<any>).map(EpisodeAdminModelToJSON),
    };
}
